import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  fetchScanPerformanceByTime,
  PerformanceScanByTime,
} from '../fetch/fetchScanPerformanceByTime';

export function useGetPerformanceScanListByTime(
  startDate: Dayjs,
  endDate: Dayjs
): {
  performanceScanList: PerformanceScanByTime[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [performanceScanList, setPerformanceScanList] =
    useState<PerformanceScanByTime[]>(null);

  const startString = dayjs(startDate).format('YYYY-MM-DD');
  const endString = dayjs(endDate).format('YYYY-MM-DD');

  useEffect(() => {
    const fetchPerformanceScanListMethod = async () => {
      const performanceScanListResult = await fetchScanPerformanceByTime(
        startString,
        endString
      );

      setPerformanceScanList(performanceScanListResult);
      setIsLoading(false);
    };

    fetchPerformanceScanListMethod();
  }, [endString, setIsLoading, startString]);

  return { performanceScanList, isLoading };
}
